<template>
  <div class>
    <STable
      ref="tableref"
      :url="url"
      :columns="columns"
      :handles="handles"
      :query="query"
      :toolbar="toolbar"
      :selection="false"
      label-width="100px"
    />
  </div>
</template>

<script>
// import x from ''
import fieldFilter from '@/utils/fieldFilter.js'
import { HOST, EV_HOST } from '@/utils/host'
export default {
  name: 'Chongdiankaguanli',
  components: {},
  data() {
    return {
      url: '/user/chargingCard/page',
      columns: [
        {
          label: '卡面卡号',
          prop: 'cardNum'
        },
        {
          label: '芯片码',
          prop: 'physicalNum'
        },
        {
          label: '充电卡状态',
          prop: 'bindStatus'
        },
        {
          label: '绑定用户',
          prop: 'loginName'
        },
        {
          label: '修改时间',
          prop: 'updateDate'
        }
      ],
      // 操作栏
      handles: {
        width: 160,
        btns: [
          {
            label: '修改',
            permission: 'card.update',
            getLabelStyle: record => {
              return record.disable ? 'color: #c0c4cc;cursor: not-allowed;' : 'color:red'
            },
            getLabelDisabled: record => {
              return !!record.disable
            },
            handle: resp => {
              this.$router.push({ path: './chargingCardModify', query: { data: resp.id }})
            }
          },
          {
            label: '作废',
            permission: 'card.invalidation',
            style: 'color:red',
            getLabel: function(record) {
              return record.disable ? '恢复' : '作废'
            },
            url: '/user/chargingCard/cancel',
            method: 'get',
            isConfirm: true,
            confirmText: '是否确定执行本操作？',
            before: function(index, record) {
              const p = {
                id: record.id
              }
              return p
            },
            handle: resp => {
              this.$refs.tableref.queryTable()
            }
          }
        ]
      },
      query: [
        {
          label: '卡面卡号',
          prop: 'cardNum',
          placeholder: '请输入卡面卡号'
        },
        {
          label: '芯片码',
          prop: 'physicalNum',
          placeholder: '请输入芯片码'
        },
        {
          label: '充电卡状态',
          prop: 'status',
          type: 'select',
          placeholder: '请选择充电卡状态',
          data: [{
            value: 0,
            label: '未绑定'
          }, {
            value: 1,
            label: '已绑定'
          }, {
            value: 2,
            label: '已作废'
          }]
        },
        {
          label: '绑定用户',
          prop: 'accountName',
          placeholder: '请输入绑定用户'
        }
      ],

      toolbar: [
        {
          label: '模板下载',
          icon: 'el-icon-download',
          permission: 'card.download',
          type: 'primary',
          handle: resp => {
            const url = HOST + '/user/chargingCard/import/template'
            $.fileDownload(url, {
              httpMethod: 'get',
              data: {
                token: window.localStorage.getItem('token')
              },
              failCallback: (html, url) => {
                this.$notify({
                  title: '失败',
                  message: '模板下载失败',
                  type: 'error'
                })
              }
            })
          }
        },
        {
          label: '导入',
          permission: 'card.import',
          icon: 'el-icon-upload2',
          type: 'primary',
          isUpload: true,
          url: HOST + '/user/chargingCard/import',
          option: {
            loading: false,
            headers: {
              token: window.localStorage.getItem('token'),
              companyId: window.localStorage.getItem('curCompanyId')
            },
            beforeUpload: file => {
              this.toolbar[1].option.loading = true
            },
            onSuccess: (response, file, fileList) => {
              this.toolbar[1].option.loading = false
              if (!response.code) {
                this.$refs.tableref.queryTable()
                this.$notify({
                  title: '成功',
                  message: '批量导入成功',
                  type: 'success'
                })
                return
              }
              this.$notify({
                title: '失败',
                message: response.message,
                type: 'error'
              })
            },
            onError: (err, file, fileList) => {
              this.toolbar[1].option.loading = false
              this.$notify({
                title: '失败',
                message: '批量导入失败',
                type: 'error'
              })
            },
            onProgress: (event, file, fileList) => {}
          }
        }
      ]
    }
  },
  computed: {},
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {
  }, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" src="" scoped>
</style>



// WEBPACK FOOTER //
// src/views/chargingCard/chargingcard.vue